<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand"
    :class="{'navbar-dark': type === 'default'}"
  >
    <router-link to="/dashboard" aria-current="page" class="h4 mb-0 mr-5 text-white text-uppercase d-inline-block active router-link-active"> Dashboard </router-link>
    <router-link to="/weekstate" aria-current="page" class="h4 mb-0 text-white text-uppercase d-inline-block active router-link-active"> Week status </router-link>
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->

    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
<!--        <b-form class="navbar-search form-inline mr-sm-3"-->
<!--            :class="{'navbar-search-dark': type === 'default', 'navbar-search-light': type === 'light'}"-->
<!--            id="navbar-search-main">-->
<!--        <b-form-group class="mb-0">-->
<!--          <b-input-group class="input-group-alternative input-group-merge">-->
<!--            <b-form-input placeholder="Search" type="text"> </b-form-input>-->

<!--            <div class="input-group-append">-->
<!--              <span class="input-group-text"><i class="fas fa-search"></i></span>-->
<!--            </div>-->
<!--          </b-input-group>-->
<!--        </b-form-group>-->
<!--      </b-form>-->
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
                  <span class="avatar avatar-lg" style="background: none;">
                    <img alt="Image placeholder" :src="'img/brand/'+user.name.toLowerCase()+'-logo.png'" style="border-radius: initial">
                  </span>
          </b-media>
        </a>

        <template>

          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </b-dropdown-header>
<!--          <b-dropdown-item href="#!">-->
<!--            <i class="ni ni-single-02"></i>-->
<!--            <span>My profile</span>-->
<!--          </b-dropdown-item>-->
<!--          <b-dropdown-item href="#!">-->
<!--            <i class="ni ni-settings-gear-65"></i>-->
<!--            <span>Settings</span>-->
<!--          </b-dropdown-item>-->
<!--          <b-dropdown-item href="#!">-->
<!--            <i class="ni ni-calendar-grid-58"></i>-->
<!--            <span>Activity</span>-->
<!--          </b-dropdown-item>-->
<!--          <b-dropdown-item href="#!">-->
<!--            <i class="ni ni-support-16"></i>-->
<!--            <span>Support</span>-->
<!--          </b-dropdown-item>-->
<!--          <div class="dropdown-divider"></div>-->
          <b-dropdown-item href="#!" @click="logOut">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item>

        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapGetters({
      user: 'auth/user',
    })
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ''
    };
  },
  methods: {
    ...mapActions({
      signOut: 'auth/signOut'
    }),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    async logOut() {
      await this.signOut()

      this.$router.replace({ name: 'login' })
    }
  }
};
</script>
